// extracted by mini-css-extract-plugin
export default {"splash":"Splashscreen_splash__x3U-O","gif":"Splashscreen_gif__3KTak","image":"Splashscreen_image__24qsE","fadeIn":"Splashscreen_fadeIn__rz7J-"};